module.exports = "/_next/static/images/offlineDark-dde3ac5f0ee49823b19d61c7a9d49d75.svg";